const APIKEY = "2a74f758b6294100b951713c572ded49"
const HOST_Q10 = "https://api.q10.com/v1"

const periodosq10 = async () => { 
  const myHeaders = new Headers()
  myHeaders.append('Accept', 'application/json')
  myHeaders.append('Api-Key', APIKEY)
  const requestOptions = { method: 'GET', headers: myHeaders }
  let res1 = await fetch(`${HOST_Q10}/periodos?Offset=1&Limit=50`, requestOptions).then((response) => response.json()).catch(e=>e)
  return res1
}

const estudiante10 = async (doc) => { 
  const myHeaders = new Headers()
  myHeaders.append('Accept', 'application/json')
  myHeaders.append('Api-Key', APIKEY)
  const requestOptions = { method: 'GET', headers: myHeaders }
  let res1 = await fetch(`${HOST_Q10}/estudiantes/${doc}`, requestOptions).then((response) => response.json()).catch(e=>e)
  return res1
}

const creaditosq10 = async (periodo, cod_est) => {
  const myHeaders = new Headers()
  myHeaders.append('Accept', 'application/json')
  myHeaders.append('Api-Key', APIKEY)
  const requestOptions = { method: 'GET', headers: myHeaders }
  let res1 = await fetch(`${HOST_Q10}/creditos?Consecutivo_periodo=${periodo}&Codigo_persona=${cod_est}`, requestOptions).then((response) => response.json()).catch(e=>e)
  res1 = res1.filter((x)=>x.Estado_credito != 'Anulado' && x.Estado_credito != 'Paz y salvo')
  return res1
} 

const sumatoriacreditos = (...listas) => {
  let valor_credito = 0
  let total_pendiente = 0
  let numero_cuotas = 0
  let cuotas_pagadas = 0
  let cuotas_pagoparciales = 0
  let cuotas = []
 
  // const todos = listas.flat() 
  const todos = listas
  todos.forEach(a => {
    a.forEach(x => { 
      cuotas.push(...x.Cuotas)
      x.Cuotas.forEach(c=>{
        if(c.Pendiente==0) cuotas_pagadas += 1
        else if(c.Pagado > 0 ) cuotas_pagoparciales += 1
      })
      valor_credito += x.Valor_credito || 0
      total_pendiente += x.Total_pendiente || 0
      numero_cuotas += x.Numero_cuotas || 0
    }) 
  })

  return {
    Valor_credito: valor_credito,
    Total_pendiente: total_pendiente,
    Numero_cuotas: numero_cuotas,
    Cuotas_pagadas: cuotas_pagadas,
    Cuotas_pagoparciales: cuotas_pagoparciales,
    Cuotas: cuotas
  }
}

export const get_deuda_q10 = async (documento) => {
    let periodos = await periodosq10()
    periodos = periodos.reverse()

    const est = await estudiante10(documento)
    const cod_est = est.Codigo_estudiante 

    const allress = []
    for(let k=0;k<periodos.length;k++){
        const consecutivo = periodos[k].Consecutivo
        const rs = await creaditosq10(consecutivo,cod_est) 
        allress.push(...rs)
    }

    const sumas = sumatoriacreditos(allress)
    return sumas
}